import {
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { CartLineCollectionModel, CartLineModel, OrderLineModel } from "@insite/client-framework/Types/ApiModels";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {chain, PopulateApiParameter} from "@insite/client-framework/Store/Pages/OrderDetails/Handlers/Reorder"

export type HandlerProps = {
    parameter: HasOnSuccess & { orderDetailsData?: any };
    apiParameter?: CartLineCollectionModel;
};

replaceInChain(chain, PopulateApiParameter, async (props: HandlerProps) => {
    const order = props.parameter.orderDetailsData;
    if (!order.value) {
        throw new Error("Reorder was called but there was no order available");
    }

    props.apiParameter = {
        cartLines: order.value.orderLines!.map(
            (line: OrderLineModel) =>
                ({
                    productId: line.productId,
                    qtyOrdered: line.qtyOrdered <= 0 ? 1 : line.qtyOrdered,
                    unitOfMeasure: line.unitOfMeasure,
                } as CartLineModel),
        ),
    } as CartLineCollectionModel;
});
